import { Pipe, PipeTransform } from '@angular/core';

import { OfferStatusType } from '@shared/models/offers';

@Pipe({
  name: 'status',
})
export class StatusPipe implements PipeTransform {
  transform(value: OfferStatusType, investor = true): string {
    if (value === 'DONE' && investor) {
      return 'bought';
    } else if (value === 'DONE' && !investor) {
      return 'sold';
    }
    return value.toLowerCase();
  }
}
